import React, { Fragment, useState, useEffect } from "react";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

import TreePlantation1 from "../../images/tree-plantation/treeplant1.webp";
import TreePlantation2 from "../../images/tree-plantation/treeplant2.webp";
import TreePlantation3 from "../../images/tree-plantation/treeplant3.webp";
import TreePlantation4 from "../../images/tree-plantation/treeplant4.webp";
import TreePlantation5 from "../../images/tree-plantation/treeplant5.webp";
import TreePlantation6 from "../../images/tree-plantation/treeplant6.webp";
import TreePlantation7 from "../../images/tree-plantation/treeplant7.webp";
import TreePlantation8 from "../../images/tree-plantation/treeplant8.webp";
import TreePlantation9 from "../../images/tree-plantation/treeplant9.webp";
import TreePlantation10 from "../../images/tree-plantation/treeplant10.webp";
import TreePlantation11 from "../../images/tree-plantation/treeplant11.webp";
import TreePlantation12 from "../../images/tree-plantation/treeplant12.webp";
import TreePlantation13 from "../../images/tree-plantation/treeplant13.webp";
import TreePlantation14 from "../../images/tree-plantation/treeplant14.webp";
import TreePlantation15 from "../../images/tree-plantation/treeplant15.webp";

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet';

const TreePlantation = ({ path }) => {

  // Setting metadata and schemadata 
  const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
  const [schemadata, setSchemadata] = useState({});
  
  // Getting the schemadata and setting the schema data. 
  useEffect(() => {
    let tempMetadata = metadataJSON[path];
    let tempSchemadata = schemadataJSON[path];

    if(tempMetadata){
      setMetadata(tempMetadata);
    }else {
      tempMetadata = {
          title: "JJFIndia | Gallery",
          description: "JJFIndia Gallery page",
          keywords: "",
          robots: "index, follow",
          canonical: "https://jjfindia.com/gallery/tree-plantation",
          openGraph: {
              title: "JJFIndia | Gallery",
              description: "JJFIndia Gallery page",
              url: "https://jjfindia.com/gallery/tree-plantation"
          },
          twitter: {
              card: "summary_large_image",
              title: "JJFIndia | Gallery",
              description: "JJFIndia Gallery page"
          }
      }

      setMetadata(tempMetadata);
    }

    // setting schema data 
    if(tempSchemadata) {
        setSchemadata(tempSchemadata);
    }

  }, [path]);

  return (
    <>

      <Helmet>
        {/* Basic Meta Tags */}
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <meta name="robots" content={metadata.robots} />

        {/* Canonical URL */}
        <link rel="canonical" href={metadata.canonical} />

        {/* Open Graph */}
        <meta property="og:title" content={metadata.openGraph?.title} />
        <meta property="og:description" content={metadata.openGraph?.description} />
        <meta property="og:url" content={metadata.canonical} />

        {/* Twitter Cards */}
        {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
        <meta name="twitter:title" content={metadata.twitter?.title} />
        <meta name="twitter:description" content={metadata.twitter?.description} />
        
        {/* Setting up schema data */}
        <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
      </Helmet>

      <Fragment>
        <Header hclass={"header--styleFour"} />
        <main className="page_content">
          <PageTitle
            pageTitle={"Tree Plantation"}
            pagesub={"Gallery"}
          />

          {/* <div className='mt-5 pt-4 pb-100'>
                      <About2 />
                  </div> */}

          <section className="blog pt-60">
            <div className="container">
              <div className="row align-items-end">
                <div className="col-12">
                  <div className="sectionTitle mb-40">
                    <span className="sectionTitle__small justify-content-center">
                      <i className="fa-solid fa-heart btn__icon"></i>Tree
                      Plantation
                    </span>
                    <h1 className="sectionTitle__big text-center">Tree Plantation</h1>
                    <p className="text-center" style={{ fontSize: "24px" }}>
                      Captured moments of our efforts to make the world greener
                      and more sustainable.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      {/* <Link to="#" */}
                      {/* onClick={(e) => e.preventDefault()} className="blogBlock__figure__link"> */}
                      <img
                        src={TreePlantation1}
                        alt="Students attending a tree plantation awareness session"
                        className="blogBlock__figure__image"
                      />
                      {/* </Link> */}
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation2}
                        alt="Teacher guiding a student during plantation activity"
                        className="blogBlock__figure__image"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation3}
                        alt="Seed balls prepared for tree plantation"
                        className="blogBlock__figure__image"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation4}
                        alt="Kids sitting in a hall raising books during an awareness session"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation5}
                        alt="Teachers and team standing outdoors with a banner behind"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation6}
                        alt="Students and volunteers planting a sapling"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation7}
                        alt="Group of students and team members with campaign posters inside a hall"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation8}
                        alt="Table displaying saplings and eco-friendly kits with a campaign banner"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation9}
                        alt="Volunteer distributing materials to students seated in a hall"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation10}
                        alt="Saplings displayed on a table with campaign leaflets"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation11}
                        alt="Teacher addressing students with eco kits on the table"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation12}
                        alt="Volunteers preparing soil and planting trees"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation13}
                        alt="Worker planting a sapling along a protected green zone"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation14}
                        alt="Team watering newly planted saplings outside a school"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="blogBlock blogBlock--style3 mb-60">
                    <figure className="blogBlock__figure">
                      <img
                        src={TreePlantation15}
                        alt="Group of volunteers holding a foundation banner in a plantation area"
                        className="blogBlock__figure__image"
                        width={400}
                        loading="lazy"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <Scrollbar />
      </Fragment>
    </>
  );
};

export default TreePlantation;
